import './node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/esnext.iterator.constructor.mjs';
import './node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/esnext.iterator.filter.mjs';
import './node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/esnext.iterator.find.mjs';
import { CorpType, Prefixes } from './constant.mjs';
import FUC_CODE from './fucCode.mjs';
import MY_DATA_ORG_CODE from './myDataOrgCode.mjs';
import { FINANCIAL_CODE_DICTIONARY } from './dict/data.mjs';

function isMydataOrgCode(value) {
  return typeof value === 'string' && Object.values(MY_DATA_ORG_CODE).includes(value);
}
function isFucCode(value) {
  return typeof value === 'string' && Object.values(FUC_CODE).includes(value);
}
function isCardMyDataOrgCode(value) {
  return isMydataOrgCode(value) && (value.slice(0, 2) === 'D1' || value.slice(0, 2) === 'D2');
}
function getKeyByFucCode(value) {
  const found = Object.entries(FUC_CODE).find(_ref => {
    let [, item] = _ref;
    return item === value;
  }) || [];
  if (found.length) {
    return found[0];
  }
  throw new Error(`${value}는 올바른 FucCode가 아닙니다.`);
}
function getKeyByMydataOrgCode(value) {
  const found = Object.entries(MY_DATA_ORG_CODE).find(_ref2 => {
    let [, item] = _ref2;
    return item === value;
  }) || [];
  if (found.length) {
    return found[0];
  }
  throw new Error(`${value}는 올바른 MydataOrgCode가 아닙니다.`);
}
function getKeyByName(value) {
  let defaultType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CorpType.BANK;
  const found = Object.entries(FINANCIAL_CODE_DICTIONARY).filter(_ref3 => {
    let [, item] = _ref3;
    return item.name === value;
  });
  if (found.length) {
    const defaultTypeKey = found.find(_ref4 => {
      let [, {
        type
      }] = _ref4;
      return type === defaultType;
    });
    if (defaultTypeKey?.length) {
      return defaultTypeKey[0];
    }
    return found[0][0];
  }
  throw new Error(`${value}는 매핑되어 있는 이름이 아닙니다.`);
}
function isBankKey(value) {
  return typeof value === 'string' && value.startsWith('BK_');
}
function isInvestKey(value) {
  return typeof value === 'string' && value.startsWith('IV_');
}
function isCardKey(value) {
  return typeof value === 'string' && value.startsWith('CD_');
}
function isSavingBankKey(value) {
  return typeof value === 'string' && value.startsWith('SB_');
}
function isCapitalKey(value) {
  return typeof value === 'string' && value.startsWith('CAPITAL_');
}
function isInsuranceKey(value) {
  return typeof value === 'string' && value.startsWith('IS_');
}
function isTelecomKey(value) {
  return typeof value === 'string' && value.startsWith('TEL_');
}
function isPointKey(value) {
  return typeof value === 'string' && value.startsWith('POINT_');
}
function getPrefixByKey(key) {
  if (isBankKey(key)) {
    return Prefixes[1];
  }
  if (isInvestKey(key)) {
    return Prefixes[2];
  }
  if (isInsuranceKey(key)) {
    return Prefixes[3];
  }
  if (isCapitalKey(key)) {
    return Prefixes[4];
  }
  if (isSavingBankKey(key)) {
    return Prefixes[5];
  }
  if (isCardKey(key)) {
    return Prefixes[6];
  }
  if (isTelecomKey(key)) {
    return Prefixes[7];
  }
  if (isPointKey(key)) {
    return Prefixes[8];
  }
  return Prefixes[0];
}

export { getKeyByFucCode, getKeyByMydataOrgCode, getKeyByName, getPrefixByKey, isBankKey, isCapitalKey, isCardKey, isCardMyDataOrgCode, isFucCode, isInsuranceKey, isInvestKey, isMydataOrgCode, isPointKey, isSavingBankKey, isTelecomKey };
